import React, { ReactNode } from "react";
import { classNames } from "../utils";

type Props = {
  title?: string | JSX.Element;
  children?: ReactNode;
  className?: string;
};

const FormTwoColumnContainer = ({ title, children, className }: Props) => {
  return (
    <div className={classNames("flex mb-6", className ?? "")}>
      <div className="w-80 font-semibold text-xl leading-7 text-gray-900">
        {title ?? ""}
      </div>
      <div className="flex-1">{children}</div>
    </div>
  );
};

export default FormTwoColumnContainer;
